import Utils from './Utils';

/**
 * Localized label used in layout pickers and editor side lists.
 *
 * @param {{ name?: object|string }} layout
 * @param {string} lang
 * @returns {string}
 */
export function layout_list_title(layout, lang) {
    return Utils.localized_or_fallback(layout?.name, lang) || '';
}

/**
 * Alphabetical order by the UI language name (case-insensitive, numeric-aware).
 *
 * @param {Array} layouts
 * @param {string} lang
 * @returns {Array}
 */
export function sort_layouts_by_localized_name(layouts, lang) {
    if (!Array.isArray(layouts))
        return [];

    return [...layouts].sort((a, b) =>
        layout_list_title(a, lang).localeCompare(layout_list_title(b, lang), lang, {
            sensitivity: 'base',
            numeric: true,
        })
    );
}
